import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TimeAgo from 'react-timeago';
import Avatar from '../../containers/User/Avatar/Avatar';
import style from './NotificationCellStyle';
import push from '../../../utils/routing';
import { EntityTypesByCollections } from '../../../../core/utils/commentsEntityTypes';
import getCommentEntityUrl from '../../../../core/utils/getCommentEntityUrl';

const timeFormatter = (value, unit, suffix) => {
  if (value <= 60 && unit === 'second') {
    return 'Just Now';
  }
  let unitPluralized = unit;
  if (value !== 1) {
    unitPluralized += 's';
  }
  return `${value} ${unitPluralized} ${suffix}`;
};

const NotificationCell = ({
  notification,
  onClick,
  culprit,
  time,
  newBadge,
}) => {
  const [hover, setHover] = useState(false);

  const handleNotificationClick = () => {
    const { action, itemId, parentItemId, spaceId, parentItemType } =
      notification;
    onClick(itemId);

    switch (action) {
      case 'newPost': {
        push(`dashboard/${spaceId}/community/post/${itemId}`);
        break;
      }
      case 'newCommentOnCommentedPost':
      case 'newComment':
      case 'newCommentReply': {
        push(
          getCommentEntityUrl({
            spaceId,
            entityType: EntityTypesByCollections[parentItemType],
            entityId: parentItemId,
          })
        );
        break;
      }
      default:
        break;
    }
  };

  return (
    <Paper
      style={style.paper}
      onClick={handleNotificationClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      elevation={hover ? 4 : 1}
    >
      <div style={style.innerContainer}>
        <div style={style.avatarContainer}>
          <Avatar
            style={style.avatar}
            user={culprit}
            isInstructor={culprit.isInstructor}
            size={45}
          />
        </div>
        <span style={style.infoContainer}>
          <div style={style.titleLabel}>
            <span
              style={{
                ...(culprit.isInstructor ? style.instructor : {}),
              }}
            />
            {culprit.isInstructor ? (
              <span style={{ ...style.instructor, ...style.instructorLabel }}>
                {' '}
                (Educator){' '}
              </span>
            ) : null}
            <span style={style.content}>
              {notification.alert.replace(/<[^>]+>/g, '')}
            </span>
          </div>
          <div style={style.timeLabel}>
            <TimeAgo date={time} minPeriod={60} formatter={timeFormatter} />
          </div>
        </span>
        {newBadge ? <div style={style.newBadge} /> : null}
      </div>
    </Paper>
  );
};

NotificationCell.propTypes = {
  time: PropTypes.string.isRequired,
  newBadge: PropTypes.bool.isRequired,
  culprit: PropTypes.shape({
    isInstructor: PropTypes.bool,
  }).isRequired,
  notification: PropTypes.shape({
    action: PropTypes.string,
    itemId: PropTypes.string,
    parentItemId: PropTypes.string,
    spaceId: PropTypes.string,
    parentItemType: PropTypes.string,
    alert: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NotificationCell;
